import React, { useEffect, useState } from "react";
import { fetchNews, FetchNewsParams } from "./news-service";
import { NewsArticle } from "./News";

// Helper: get today's or yesterday's date
const getDate = (daysAgo: number): string => {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().split("T")[0]; // yyyy-mm-dd
};

const NewsGrid: React.FC = () => {
  const [articles, setArticles] = useState<NewsArticle[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // Filters
  const [q, setQ] = useState<string>("india");
  const [category, setCategory] = useState<string>("general");
  const [fromDate, setFromDate] = useState<string>(getDate(1));
  const [toDate, setToDate] = useState<string>(getDate(0));
  const [language, setLanguage] = useState<string>("en");
  const [country, setCountry] = useState<string>("in");
  const [domain, setDomain] = useState<string>("");

  // Pagination
  const [nextPage, setNextPage] = useState<string | undefined>(undefined);

  const loadNews = async (reset = true) => {
    setLoading(true);
    setError(null);
    try {
      const params: FetchNewsParams = {
        q,
        category,
        from_date: fromDate,
        to_date: toDate,
        language,
        country,
        domain: domain || undefined,
        page: reset ? undefined : nextPage,
      };

      const data = await fetchNews(params);

      setArticles((prev) =>
        reset ? data.articles ?? [] : [...prev, ...(data.articles ?? [])]
      );
      setNextPage(data.nextPage);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadNews(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, category, fromDate, toDate, language, country, domain]);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-gray-100">
        News Articles
      </h2>

      {/* 🔎 Filters */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4"> */}
        {/* <input
          type="text"
          placeholder="Search..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="border p-2 rounded"
        /> */}
        {/* <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="border p-2 rounded"
        >
          <option value="general">General</option>
          <option value="business">Business</option>
          <option value="technology">Technology</option>
          <option value="sports">Sports</option>
          <option value="health">Health</option>
          <option value="science">Science</option>
          <option value="entertainment">Entertainment</option>
        </select> */}
        {/* <input
          type="date"
          value={fromDate}
          max={getDate(0)}
          onChange={(e) => setFromDate(e.target.value)}
          className="border p-2 rounded"
        />
        <input
          type="date"
          value={toDate}
          max={getDate(0)}
          onChange={(e) => setToDate(e.target.value)}
          className="border p-2 rounded"
        /> */}
        {/* <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="border p-2 rounded"
        >
          <option value="en">English</option>
          <option value="hi">Hindi</option>
          <option value="fr">French</option>
        </select> */}
      {/* </div> */}

      {loading && <p className="text-gray-700 dark:text-gray-300">Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && articles.length === 0 && (
        <p className="text-gray-700 dark:text-gray-300">No articles found.</p>
      )}

      {/* News Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {articles.map((a) => (
          <div
            key={a.article_id}
            className="border rounded-lg p-4 shadow-sm bg-white dark:bg-gray-900"
          >
            {a.image_url && (
              <img
                src={a.image_url}
                alt={a.title}
                className="w-full h-40 object-cover rounded mb-2"
              />
            )}
            <h3 className="font-semibold text-gray-900 dark:text-blue-600">
              {a.title}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {a.description}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              {a.source_name} • {new Date(a.pubDate).toLocaleDateString()}
            </p>
            <a
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 hover:underline text-sm mt-2 block"
            >
              Read more →
            </a>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {nextPage && !loading && (
        <div className="flex justify-center mt-4">
          <button
            className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-100 rounded"
            onClick={() => loadNews(false)}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsGrid;
